import { render, staticRenderFns } from "./VideoListing.vue?vue&type=template&id=0ff593d0&scoped=true"
import script from "./VideoListing.vue?vue&type=script&lang=js"
export * from "./VideoListing.vue?vue&type=script&lang=js"
import style0 from "./VideoListing.vue?vue&type=style&index=0&id=0ff593d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff593d0",
  null
  
)

export default component.exports